import { t } from "@lingui/macro";

import {
  Radio,
  RadioGroup,
} from "@whoosh/design-system/src/components/controls";
import {
  HStack,
  VStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { TeeSheetFilterType } from "../../types";

type TeeSheetViewFilterRadioGroupProps = {
  value: TeeSheetFilterType;
  onChange: (value: TeeSheetFilterType) => void;
};
export const TeeSheetViewFilterRadioGroup = ({
  value,
  onChange,
}: TeeSheetViewFilterRadioGroupProps) => {
  return (
    <VStack>
      <Text maxFontSizeMultiplier={2} py={2} mb={4} variant="mainSmallSemiBold">
        {t`View`}
      </Text>
      <RadioGroup
        value={value}
        accessibilityLabel={t`View radio group`}
        onChange={(val) => {
          /**
           * Not sure how to better type this one. If you see a way, please fix
           */
          onChange(val as unknown as TeeSheetFilterType);
        }}
      >
        <HStack gap={3} alignItems="center">
          <Radio
            value="All"
            testID="radio-all"
            accessibilityLabel={t`All Times`}
          />
          <Text
            maxFontSizeMultiplier={2}
            variant="mainBaseMedium"
          >{t`All Times`}</Text>
        </HStack>

        <HStack gap={3} alignItems="center">
          <Radio
            value="Available"
            testID="radio-available"
            accessibilityLabel={t`Available Times Only`}
          />
          <Text
            maxFontSizeMultiplier={2}
            variant="mainBaseMedium"
          >{t`Available Times Only`}</Text>
        </HStack>
      </RadioGroup>
    </VStack>
  );
};
